import axios from "axios"

const URL = process.env.REACT_APP_API_URL
const BASE_URL = `${URL}/api/leads`
const axiosApi = axios.create({
    baseURL: BASE_URL
})

axiosApi.interceptors.request.use(req => {
    const token = JSON.parse(localStorage.getItem('token'));
    if(token){
        req.headers.Authorization = token
    }
    return req
})

export const DashboardApis = {
    listAll: async(offset,limit,filter) => {
        return axiosApi.get(`${BASE_URL}?page=${offset}&limit=${limit}&filter=${filter}`)
    },
    getById: async(id) => {
        return axiosApi.get(`${BASE_URL}/${id}`)
    },
    create: async(data) => {
        return axiosApi.post(`${BASE_URL}`, data)
    },
    update: async(id, data) => {
        return axiosApi.put(`${BASE_URL}/${id}`, data)
    },
    delete: async(id) => {
        return axiosApi.delete(`${BASE_URL}/${id}`)
    },
    export: async(filter) => {
        const filterParam = filter ? `?filter=${encodeURIComponent(filter)}` : ''
        return axiosApi.get(`${BASE_URL}/export/excel${filterParam}`, { responseType: 'blob' })
    },
    filters: async() => {
        return axiosApi.get(`${BASE_URL}/filters`)
    }
}
